import ChangeLog from './ChangeLog.component';
export default ChangeLog;